<template>
  <v-dialog v-model="visible" scrollable max-width="600px">
    <v-card>
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ $t('toolbar-title') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="visible = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pt-4">
        <div v-if="$autocompletion.get('keywords').length === 0">
          {{ $t('empty-keywords') }}
        </div>
        <v-row v-else>
          <v-col cols="12" class="mt-4">
            <v-btn @click="remove()" text>
              <v-icon left>mdi-delete</v-icon>
              {{ $t('actions.remove-all') }}
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">{{ $t('name') }}</th>
                  <th class="text-right"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="keyword in $autocompletion.get('keywords')" :key="keyword">
                  <td class="text-left">{{ keyword }}</td>
                  <td class="text-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small icon color="warning" @click="remove(keyword)" v-bind="attrs" v-on="on">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t('remove-keyword') }}</span>
                    </v-tooltip>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'KeywordCompletionDialog',
  data () {
    return {
      visible: false
    }
  },
  methods: {
    remove (value) {
      if (value) this.$autocompletion.remove('keywords', value)
      else this.$autocompletion.purge('keywords')
    }
  },
  mounted () {
    this.$bus.on('dialog/keyword_completion/open', () => {
      this.visible = true
    })
  }
}
</script>

<i18n>
{
	"en": {
		"empty-keywords": "You don't have any memorized keywords.",
		"name": "Name",
		"remove-keyword": "Remove keyword",
		"toolbar-title": "Memorized keywords"
	},
	"es": {
		"empty-keywords": "No tiene ninguna palabra clave memorizada.",
		"name": "Apellido",
		"remove-keyword": "Eliminar palabra clave",
		"toolbar-title": "Palabras clave memorizadas"
	},
	"fr": {
		"empty-keywords": "Vous n'avez pas de mots clés mémorisés.",
		"name": "Nom",
		"remove-keyword": "Supprimer le mot-clé",
		"toolbar-title": "Mots-clés mémorisés"
	},
	"it": {
		"empty-keywords": "Non hai parole chiave memorizzate.",
		"name": "Nome",
		"remove-keyword": "Rimuovi parola chiave",
		"toolbar-title": "Parole chiave memorizzate"
	},
	"pt": {
		"empty-keywords": "Não tem palavras-chave memorizadas.",
		"name": "Nome",
		"remove-keyword": "Eliminar palavra-chave",
		"toolbar-title": "Palavras-chave memorizadas"
	},
	"pl": {
		"empty-keywords": "Nie masz żadnych zapamiętanych słów kluczowych.",
		"name": "Nazwa",
		"remove-keyword": "Usuń słowo kluczowe",
		"toolbar-title": "Zapamiętane słowa kluczowe"
	}
}
</i18n>
